import w2aDevice from "./w2aDevice.js"
import w2aMobileDetect from "./w2aMobileDetect"
import w2aClipboard from 'clipboard/dist/clipboard';
import w2aRequest from "./request"
import {
  getLibOrigin
} from '@bbtfe/utils';
const w2astat = {}; //sdk方法对象
// let baseUrl = '//mapiweb.1.java.babytree-test.com/newapi/luban/w2a/init'; //上报url（测试）
let baseUrl = '//mapiweb.babytree.com/newapi/luban/w2a/init'; //上报url（线上）
let pageStamp; //页面加载时间戳
let feature = {}; //手机信息
let dpTarget = {}; //dp目标元素
let urlParams;
//初始化方法
const init = () => {
  pageStamp = new Date().getTime(); //获取进入页面时间戳
  loadScripts();
  urlParams = getUrlParams();
  console.log('w2a.init执行')
};
// 解析url获取页面参数
const getUrlParams = () => {
  const res = {};
  if (!location.search) return res;
  const search = location.search.substr(1);
  search.split('&').forEach(paramStr => {
    const arr = paramStr.split('=');
    const key = arr[0];
    const value = arr[1];
    res[key] = value;
  });
  console.log('w2a.getUrlParams执行')
  return res;
};
// 加载依赖脚本，脚本加载完毕执行sdk逻辑。（判断window全局对象下有没有依赖方法，没有时加载）
const createScript = (src, callback) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = 'async';
  script.src = src;
  let loaded = false;
  script.onload = script.onreadystatechange = function () {
    if (
      (script.readyState &&
        script.readyState !== 'complete' &&
        script.readyState !== 'loaded') ||
      loaded
    ) {
      return false;
    }
    script.onload = script.onreadystatechange = null;
    loaded = true;
    callback && callback();
    console.log('w2a.createScript执行1')
  };
  script.onerror = function () {
    script.onload = script.onreadystatechange = null;
    setTimeout(() => {
      createScript(src, callback);
    }, 500)
  };
  const head = document.getElementsByTagName('head')[0];
  head.insertBefore(script, head.firstChild);
  console.log('w2a.createScript执行2')
};
// 动态加载脚本
const loadScripts = () => {
  if (window.bbtTracking) {
    w2aInfoInit();
  } else {
    createScript("//static02.babytreeimg.com/img/bca/tracking/0.2.4/tracking.min.js", w2aInfoInit);
  }
};
// 处理w2a-send类元素，根据自定义属性获取参数值。
const w2aInfoInit = () => {
  // 获取w2a-send类名的dom元素
  // let btnDoms = document.getElementsByClassName('w2a-send');
  // for (let i = 0; i < btnDoms.length; i++) {
  //   btnDoms[i].setAttribute('data-index', i);
  // }
  // 手机信息上报入参处理
  let os = w2aDevice.getOsVersion();
  let md = new w2aMobileDetect(window.navigator.userAgent);
  let canvas = document.createElement('canvas');
  let gl = canvas.getContext('webgl');
  let debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  var user_agent = navigator.userAgent;
  var newMobile = md.phone();
  if (md.os() && md.os().toLowerCase() == 'androidos') {
    var sss = user_agent.split(';');
    let index = -100;
    for (let i = 0; i < sss.length; i++) {
      if (sss[i].indexOf('Build/') != -1) {
        index = i;
      }
    }
    if (index > -1) {
      newMobile = sss[index].substring(0, sss[index].indexOf('Build/')).trim();
    }
  }
  feature = {
    os: os, //系统
    mobile: newMobile || 'udf', //手机型号
    phone: md.mobile() || 'udf', //手机
    gpu: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || 'udf', //gpu名称
    platform: window.navigator.platform || 'udf', //平台名称
    sc_w: window.screen.width || 'udf', //屏幕宽
    sc_h: window.screen.height || 'udf', //屏幕高
    locip: 'udf' //本地ip
  };
  console.log('feature.........' + feature)
  // 获取本地ip
  w2aDevice.getIP(function (ip) {
    feature.locip = ip || 'udf';
    console.log('feature.locip.......' + feature.locip)
  });
  console.log('w2a.w2aInfoInit执行')
};
// 上报手机信息，发送请求。params:bid按钮id，params上报按钮业务参数，jumplink按钮跳转链接
const sendUrl = () => {
  let {
    params,
    jumplink,
    tid,
    channel,
    bid
  } = dpTarget;
  let href = document.location.href;
  let fpHref = document.referrer;
  let ts = new Date().getTime();
  let channelVal = urlParams.channelCode || channel || '';
  let postData = {
    data: {
      feature,
      config: {
        view: jumplink || window.location.href, // 路由设置，供APP参考并跳转至业务，遵循DeepLink的规则
        appid: '11' // 孕育或小时光的 appID
      },
      bdata: {
        bid: bid || channelVal + '0', //业务ID
        param: params || {}
      },
      tdata: {
        // 统计参考数据集
        tid: tid || 'udf', // 统计项关联ID
        url: href, // 当前网页url
        refer: fpHref || 'udf', // 网页refer，提供统计参考
        timestamp: pageStamp, // 网页触发业务的时间戳
        channel: channelVal // 渠道名称，如farm_cow
      }
    },
    ts,
    app_id: '11'
  };
  console.log(postData)
  w2aRequest({
      params: postData,
      url: baseUrl
    })
    .then(res => {
      if (res.status == 200) {
        console.log('w2aRequest success')
        let text = res.data && res.data.data && res.data.data.copy;
        copy(text);
      }
    })
    .catch(() => {
      filterDP(); //dp流程
    });
};
// 上报请求返回值存入剪切板。成功回调走dp流程
const copy = text => {
  var button = document.createElement('button');
  button.setAttribute('id', 'input_for_copyText');
  button.setAttribute(
    'style',
    'position:fixed;bottom:0;width:0;height:0;cursor:pointer'
  );
  button.setAttribute('data-clipboard-text', text);
  button.addEventListener('click', function () {});
  document.getElementsByTagName('body')[0].appendChild(button);
  var clipboard = new w2aClipboard('#input_for_copyText');
  setTimeout(() => {
    button.click();
    filterDP(); //dp流程
  }, 500);
  clipboard.on('success', function (e) {
    e.clearSelection();
  });
  clipboard.on('error', function (e) {
    e.clearSelection();
  });
};
//dp流程
const filterDP = () => {
  if (!window.WLA) {
    createScript(
      `${getLibOrigin()}/h5_fe_lib/release/wla/current/index.min.js?${
        process.env.VERSION
      }`,
      openWLA
    );
  } else {
    openWLA();
  }
};
const openWLA = () => {
  // 创建wla对象，用于dp流程
  let wlaObj = new WLA({
    auto: false,
    scheme: dpTarget.jumplink || window.location.href,
    useWta: false,
    pkgs: {
      channel: {
        refcode: dpTarget.refcode || '',
        url: '//r.babytree.com/gL94t8K'
      }
    }
  });
  wlaObj.open();
};
// 按钮点击事件，埋点+w2a上报
const domClick = data => {
  let {
    track
  } = data;
  dpTarget = data;
  if (track && bbtTracking && bbtTracking.send) {
    bbtTracking.send(track);
  }
  sendUrl();
};
w2astat.init = init;
w2astat.send = domClick;
window.w2astat = w2astat;

export default w2astat;